import { render, staticRenderFns } from "./CompanyBasicInfoForm.vue?vue&type=template&id=1db342e7&"
import script from "./CompanyBasicInfoForm.vue?vue&type=script&lang=js&"
export * from "./CompanyBasicInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VForm,VRow,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/working_dir/management-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1db342e7')) {
      api.createRecord('1db342e7', component.options)
    } else {
      api.reload('1db342e7', component.options)
    }
    module.hot.accept("./CompanyBasicInfoForm.vue?vue&type=template&id=1db342e7&", function () {
      api.rerender('1db342e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Companies/Forms/CompanyBasicInfoForm.vue"
export default component.exports